import {useState} from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idAnswersCreateType4 } from '../../../adminSlice';

const AddInputFormsForAnswersType4  = (props) => {

            
        const [userInputContentCompare, setUserInputContentCompare] = useState('');
        const [userInputContentSource, setUserInputContentSource] = useState('');
        

const { dispatch } = props;
  
 // CLICK OK
const onSend = () => {
        
        const item = {
            content_compare: userInputContentCompare,
            
             content_source: userInputContentSource,

            question_id: props.adminState.selectedQuestion,
            //quiz_id: props.adminState.selectedQuize
            
        }
        console.log(item);
        dispatch(idAnswersCreateType4(item));  
}
// ENTER INPUT
const handleUserInputContentCompare = (e) => {

            setUserInputContentCompare(e.target.value);

}
const handleUserInputContentSource = (e) => {

            setUserInputContentSource(e.target.value);

}





// CLOSE FORM
const onClose = () => {

    dispatch(closeInputForms());

}

   

     
        return(
            <div className="InputFormsForQuizes">
                           


             <p>Создать новый ответ:</p>
             <form>
             
                 <label>
                     Текст бокса/утверждение</label>
                 <textarea  onChange={handleUserInputContentCompare} 
                 ></textarea>
                <label>
                     Текст бокса/сопоставление</label>
                 <textarea  onChange={handleUserInputContentSource} 
                 ></textarea>


             </form>
             <button onClick={onSend}>OK</button>
             <button onClick={onClose}>Отмена</button>
            </div>
        )
     
       
     

        
    
}

export default AddInputFormsForAnswersType4;